import React from "react";
import createNamespace from "services/language";
import Route, {
  ADMIN_PREFIX_WITH_PROJECT,
} from "components/common/History/Route";
import { CLUSTER_DEFINITIONS } from "utils/constants/routes";
import ProjectContextProvider from "components/common/History/ProjectContextProvider";

const Index = React.lazy(() => import("./index"));
const CreatePolicy = React.lazy(() => import("./policies/create"));
const ClusterTemplateDetails = React.lazy(() => import("./templates/details"));
const CreateTemplate = React.lazy(() => import("./templates/create"));

export default createNamespace({
  namespace: "clusterdefinitions",
  Component: function Main() {
    return (
      <>
        <Route
          adminEnabled
          exact
          path={CLUSTER_DEFINITIONS.ROOT}
          component={Index}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTER_DEFINITIONS.CREATE_POLICY}
          component={CreatePolicy}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTER_DEFINITIONS.EDIT_POLICY}
          component={CreatePolicy}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTER_DEFINITIONS.TEMPLATE_OVERVIEW}
          component={ClusterTemplateDetails}
        />
        <Route
          exact
          adminOnly
          path={`${ADMIN_PREFIX_WITH_PROJECT.replace("/admin", "")}${
            CLUSTER_DEFINITIONS.TEMPLATE_OVERVIEW
          }`}
          component={(props) => (
            <ProjectContextProvider>
              <ClusterTemplateDetails {...props} />
            </ProjectContextProvider>
          )}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTER_DEFINITIONS.CREATE_TEMPLATE}
          component={CreateTemplate}
        />
      </>
    );
  },
});
